module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBoldItalic.f18b40d.woff2";